import React from 'react';

// Barra fija abajo del todo en el móvil, con el margen de la zona segura del
// iPhone y una sombra hacia arriba. Queda por debajo de las hojas (z-55) y de
// los modales de la ficha (z-50).
export default function BarraInferiorMovil({ children, className = '', ...resto }) {
  return (
    <div
      className={`fixed bottom-0 inset-x-0 z-40 bg-white border-t border-[#E1E6E3] shadow-[0_-4px_12px_rgba(22,34,29,0.08)] ${className}`}
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      {...resto}
    >
      {children}
    </div>
  );
}
